module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_7.19cd6dac.jpg";